export default "__VITE_ASSET__BnMuOhAm__"